import React, { useMemo } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useContent } from "../context/ContentContext";

const DEFAULT_SYSTEM_OPTIONS = [
  {
    label: "CRISPR & Sickle Cell",
    systemId: "2985689a-bf21-4e46-8596-f2f59c2b953d",
  },
  {
    label: "Trouble in Sunshine Creek",
    systemId: "ae082427-fe04-49b8-9767-f332025bc23d",
  },
  {
    label: "Tarantula Toxins",
    systemId: "ccc77f90-ff23-4468-9038-fb52787c0530",
  },
];

const SystemOptionsDropdown = ({
  value,
  onChange,
  defaultOptions = DEFAULT_SYSTEM_OPTIONS,
  label = "Select System",
  margin = "normal",
  size = "medium",
  sx,
}) => {
  const { mySystems } = useContent();

  // Map fetched systems if necessary (assuming API returns objects with `id` and `name`)
  const fetchedSystems = (Array.isArray(mySystems) ? mySystems : []).map((system) => ({
    systemId: system.systemId || system.id,
    label: system.label || system.name,
  }));

  const allSystems = useMemo(() => {
    const seenSystemIds = new Set();

    return [...defaultOptions, ...fetchedSystems].filter((option) => {
      if (!option?.systemId || !option?.label || seenSystemIds.has(option.systemId)) {
        return false;
      }

      seenSystemIds.add(option.systemId);
      return true;
    });
  }, [defaultOptions, fetchedSystems]);

  return (
    <FormControl fullWidth margin={margin} size={size} sx={sx}>
      <InputLabel id="system-options-label">{label}</InputLabel>
      <Select
        labelId="system-options-label"
        value={value ?? ""}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        {allSystems.map((option) => (
          <MenuItem key={option.systemId} value={option.systemId}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SystemOptionsDropdown;
